

















import Store from "@/shared/global-store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GlobalNotification extends Vue {
    get notification() {
        return Store.state.globalNotification;
    }

    static close() {
        Store.hideGlobalNotification();
    }

    onDismiss(value: boolean) {
        if (!value) {
            Store.hideGlobalNotification();
        }
    }

    executeAction(action: { label: string; action: () => void; color?: string; variant?: string; icon?: string }) {
        try {
            Store.hideGlobalNotification();
            action.action();
        } catch (error) {
            console.error('Erro ao executar ação da notificação:', error);
        }
    }
}
